/**
 * Chart.js Configuration
 *
 * Registro global de todos os componentes Chart.js necessários.
 * Este arquivo deve ser importado ANTES de qualquer componente que use Chart.js.
 *
 * @since 2025-12-17
 */

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  LineElement,
  PointElement,
  Filler,
  RadialLinearScale,
} from 'chart.js';

// Registrar TODOS os componentes Chart.js globalmente
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  LineElement,
  PointElement,
  Filler,
  RadialLinearScale,
  Title,
  Tooltip,
  Legend
);

// Exportar Chart.js configurado
export { ChartJS };

// Indicar que foi registrado
export const chartJsRegistered = true;
